import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

const Text = ({ label, placeholder, value, onChange, isRequired, error }) => (
  <div className='smartchat-field text'>
    {label && (
      <div className='smartchat-field__header'>
        {label && <label>{label}</label>}
        <span>{isRequired ? `(${I18n.t('dashboard_required')})` : `(${I18n.t('dashboard_optional')})`}</span>
      </div>
    )}
    <div className='smartchat-field__body'>
      <input
        type='text'
        placeholder={placeholder}
        value={value}
        onChange={event => onChange(event.target.value.trimStart())}
        className={error && 'text--error'}
      />
    </div>
  </div>
)

export default Text
